import React from 'react';

import {
    Typography
} from '@material-ui/core';

import { useTranslation } from "react-i18next";

import EmojiPeopleIcon from '@material-ui/icons/EmojiPeopleOutlined'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

export const NotFoundPage = (props) => {
    const classes = useStyles();

    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h2">
                {t("LabelPageNotFound")}
            </Typography>
            <br />
            <Typography align="center" variant="body1">
                {t("LabelShadyPath")}
            </Typography>
            <br />
            <EmojiPeopleIcon className={classes.image} />
        </div>
    );
}